/**
 * `provide_credit` rewards (svc-promo `VoucherApplied.rewardKind`) grant wallet credit after purchase;
 * they must not reduce payable totals like `discount` rewards. They are still sent on the order as
 * `voucher` payments with `amount: 0` so svc-order can record voucher usage.
 */
export function isVoucherAppliedAsCheckoutDiscount(
  voucher: Pick<App.Checkout.AppliedVoucher, 'rewardKind'>,
): boolean {
  return voucher.rewardKind !== 'provide_credit'
}
